/* eslint-disable @scandipwa/scandipwa-guidelines/file-structure */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import { cloneElement } from 'react';

import {
    updateBillingAddress,
    updateBillingAddressId,
    updateBillingSameAsShipping,
    updatePaymentMethodCode,
    updateShippingAddress,
    updateShippingMethodCode
} from '../store/CheckoutFields/CheckoutFields.action';

const addAddresesToCheckoutShipping = (args, callback, instance) => {
    const { shippingAddress, billingAddress } = instance.props;
    const prevRender = callback(...args);
    const prevChildren = prevRender.props.children;
    const clonedChildren = cloneElement(
        prevChildren,
        {
            ...prevChildren.props,
            shippingAddress,
            billingAddress
        }
    );

    return cloneElement(
        prevRender,
        {
            ...prevRender.props
        },
        clonedChildren
    );
};

const addAdditionalPropsToSuccessPage = (args, callback, instance) => {
    const {
        updateShippingAddress,
        updatePaymentMethodCode,
        updateShippingMethodCode,
        updateBillingSameAsShipping,
        updateBillingAddressId,
        updateBillingAddress
    } = instance.props;
    const prevRender = callback(...args);
    const prevChildren = prevRender.props.children;
    const clonedChildren = cloneElement(
        prevChildren,
        {
            ...prevChildren.props,
            updateShippingAddress,
            updatePaymentMethodCode,
            updateShippingMethodCode,
            updateBillingSameAsShipping,
            updateBillingAddressId,
            updateBillingAddress
        }
    );

    return cloneElement(
        prevRender,
        {
            ...prevRender.props
        },
        clonedChildren
    );
};

const saveAddressFieldsInReducer = (args, callback, instance) => {
    const { billing_address, shipping_address } = args[0];

    instance?.props?.updateShippingAddress(shipping_address);
    instance?.props?.updateBillingAddress(billing_address);

    return callback(...args);
};

const mapDispatchToProps = (args, callback, _instance) => {
    const [dispatch] = args;

    return {
        ...callback(...args),
        updateBillingAddress: (value) => dispatch(updateBillingAddress(value)),
        updateShippingAddress: (value) => dispatch(updateShippingAddress(value)),
        updatePaymentMethodCode: (value) => dispatch(updatePaymentMethodCode(value)),
        updateShippingMethodCode: (value) => dispatch(updateShippingMethodCode(value)),
        updateBillingSameAsShipping: (value) => dispatch(updateBillingSameAsShipping(value)),
        updateBillingAddressId: (value) => dispatch(updateBillingAddressId(value))
    };
};

const mapStateToProps = (args, callback, _instance) => {
    const [state] = args;

    return {
        ...callback(...args),
        shippingAddressFields: state.CheckoutFieldsReducer.shippingAddressFields,
        billingAddressFields: state.CheckoutFieldsReducer.billingAddressFields
    };
};

const useAddresFromReducer = (args, callback, instance) => {
    callback(...args);
    const { shippingAddressFields, billingAddressFields } = instance.props;

    // eslint-disable-next-line no-param-reassign
    instance.state = {
        ...instance.state,
        shippingAddress: shippingAddressFields,
        billingAddress: billingAddressFields
    };
};

const containerProps = (args, callback, instance) => {
    const {
        updatePaymentMethodCode,
        updateShippingAddress,
        updateShippingMethodCode,
        updateBillingSameAsShipping,
        updateBillingAddressId,
        updateBillingAddress
    } = instance.props;

    return {
        ...callback(...args),
        updatePaymentMethodCode,
        updateShippingAddress,
        updateShippingMethodCode,
        updateBillingSameAsShipping,
        updateBillingAddressId,
        updateBillingAddress
    };
};

export default {
    'Route/Checkout/Component': {
        'member-function': {
            renderShippingStep: addAddresesToCheckoutShipping,
            renderDetailsStep: addAdditionalPropsToSuccessPage
        }
    },
    'Route/Checkout/Container': {
        'member-function': {
            saveAddressInformation: saveAddressFieldsInReducer,
            __construct: useAddresFromReducer,
            containerProps
        }
    },
    'Route/Checkout/Container/mapDispatchToProps': {
        function: mapDispatchToProps
    },
    'Route/Checkout/Container/mapStateToProps': {
        function: mapStateToProps
    }
};
